import { render, staticRenderFns } from "./ReportTuple.vue?vue&type=template&id=e61d3b46&scoped=true&"
import script from "./ReportTuple.vue?vue&type=script&lang=js&"
export * from "./ReportTuple.vue?vue&type=script&lang=js&"
import style0 from "./ReportTuple.vue?vue&type=style&index=0&id=e61d3b46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61d3b46",
  null
  
)

export default component.exports